import { RouteRecordRaw } from 'vue-router';
import { layoutAreaTypes } from '@/types/layoutTypes';

const unloggedRoutes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "home" */ '@/views/unloggedArea/LoginPage.vue'),
    meta: { layout: layoutAreaTypes.Unlogged },
  },
  {
    path: '/Account/ActivateUserAccount',
    name: 'Activate User Account',
    component: () => import(/* webpackChunkName: "home" */ '@/views/unloggedArea/LoginPage.vue'),
    meta: { layout: layoutAreaTypes.Unlogged },
  },
  {
    path: '/Account/ForgotPassword',
    name: 'Forgot password form',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/views/unloggedArea/ForgotPasswordMainPage.vue'),
    meta: { layout: layoutAreaTypes.Unlogged },
  },
  {
    path: '/Account/ForgotPasswordConfirmation',
    name: 'Forgot password email send confirmation',
    component: () =>
      import(
        /* webpackChunkName: "home" */ '@/views/unloggedArea/ForgotPasswordEmailSendConfirmationPage.vue'
      ),
    meta: { layout: layoutAreaTypes.Unlogged },
  },
  {
    path: '/Account/ResetPassword',
    name: 'Reset password form',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/views/unloggedArea/ForgotPasswordResetPage.vue'),
    meta: { layout: layoutAreaTypes.Unlogged },
  },
  {
    path: '/Account/ResetPasswordConfirmation',
    name: 'Reset password confirmation',
    component: () =>
      import(
        /* webpackChunkName: "home" */ '@/views/unloggedArea/ForgotPasswordResetConfirmationPage.vue'
      ),
    meta: { layout: layoutAreaTypes.Unlogged },
  },
  {
    path: '/Account/Deactivated',
    name: 'Deactivated',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/views/unloggedArea/DeactivatedPage.vue'),
    meta: { layout: layoutAreaTypes.Unlogged },
  },
  {
    path: '/Imprint',
    name: 'Imprint',
    component: () => import(/* webpackChunkName: "home" */ '@/views/unloggedArea/ImprintPage.vue'),
    meta: { layout: layoutAreaTypes.Unlogged },
  },
  {
    path: '/SsoAccount/ExternalLoginConfirmation',
    name: 'External Login Confirmation',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/views/unloggedArea/ConfirmationSsoPage.vue'),
    meta: { layout: layoutAreaTypes.Unlogged },
  },
  {
    path: '/SsoAccount/AccountLockedOut',
    name: 'Account LockedOut',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/views/unloggedArea/AccountLockedOutPage.vue'),
    meta: { layout: layoutAreaTypes.Unlogged },
  },
  {
    path: '/submission-confirmed',
    name: 'Submission Confirmed',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/views/unloggedArea/SubmissionConfirmedPage.vue'),
    meta: { layout: layoutAreaTypes.Unlogged },
  },
  {
    path: '/submission-confirmed-create-account',
    name: 'Submission Confirmed Create Account',
    component: () =>
      import(
        /* webpackChunkName: "home" */ '@/views/unloggedArea/SubmissionConfirmedCreateAccountPage.vue'
      ),
    meta: { layout: layoutAreaTypes.Unlogged },
  },
];

export default unloggedRoutes;
